<script setup lang="ts">
import { computed } from 'vue'
import { useMarketValueAsOfDate } from '~/composables/useMarketValueAsOfDate'

// The composable now returns a reactive Ref<Date> that gets swapped to
// the latest successful Orion import's SnapshotDate once the fetch
// resolves. Wrap both renderings in computeds so the footer updates
// when the real date arrives instead of locking in "today".
const asOfDate = useMarketValueAsOfDate()
// Route the full "Market Value as of {date}" through the shared formatter so
// it honors the user's date-style display pref (was a raw `toLocaleDateString`).
const { formatDate } = useFormatDate()
const formattedDate = computed(() => formatDate(asOfDate.value))
// yearOnly is deliberately year-only (copyright line) — leave as raw locale.
const yearOnly = computed(() => asOfDate.value.toLocaleDateString('en-US', {
  year: 'numeric'
}))
</script>

<template>
  <UFooter
    class="bg-white text-center text-xs text-muted justify-center shrink-0"
    :ui="{ container: 'max-w-none pl-0 sm:pl-0 md:pl-[clamp(0.5rem,1.5vw,1.5rem)] pr-4 sm:pr-6 md:pr-[clamp(0.5rem,1.5vw,1.5rem)] py-3 lg:py-5 flex items-center justify-center' }"
  >
    <template #left>
      <!-- ml-4 sm:ml-6 mirrors the page title's own margin; combined with the
           container's clamp pad this lands the text on the title's exact left
           edge. (Split out of a nested calc() — Tailwind drops clamp() nested
           inside calc() in an arbitrary value, so we never nest them.) -->
      <div class="flex items-center pr-4 ml-4 sm:ml-6">
        <p class="uppercase font-bold text-black tracking-wider">
          Market Value as Of {{ formattedDate }}
        </p>
      </div>
    </template>
    <template #right>
      <p class="uppercase hidden lg:inline text-black tracking-wider">
        Copyright © {{ yearOnly }} <a class="underline text-green-500 font-semibold" href="https://azzadasset.com">Azzad Asset.</a> All rights reserved.
      </p>
    </template>
  </UFooter>
</template>

<style scoped>

</style>
